import { OSBAPIResponse } from '../service-orchestration/service-adapter';
import {
    ErrorResponse,
    transformErrorResponse,
} from '../../../components/sections/owners-osb/osb-utils';
import { OSBApiService } from '../service-orchestration/osb-api-service';
import { OSB_API_PATH } from '../../../constants';
import { ServiceBookingResponse } from '../../../models/osb-model/osb-review-booking';
import { transformServiceResponse } from '../../../components/sections/owners-osb/osb-service-adapters/service-booking-adapter';
import { BookingCredentials } from '../../../models/osb-model/osb-booking-credentials';
import { Bookable } from '../../../hooks/owners-osb/use-all-osb-state';

export class OSBServiceBookingClient {
    public createServiceBooking(args: {
        serviceBookingRequest: Bookable;
        callback?: {
            (progressPercent: number): void;
            (arg0: number): void;
        };
    }) {
        const { serviceBookingRequest } = args;
        const {
            dealerCode,
            ...bookableWithoutDealerCode
        } = serviceBookingRequest; // FIXME: API doesnt work currently with dealer code in paylaod.
        return new Promise<OSBAPIResponse<BookingCredentials>>(
            (resolve, reject) => {
                const transformedResponse: OSBAPIResponse<BookingCredentials> = {
                    value: {} as BookingCredentials,
                    responseError: {} as ErrorResponse,
                };
                new OSBApiService()
                    .postServiceAPIOnDealerCode<
                        Omit<Bookable, 'dealerCode'>,
                        ServiceBookingResponse
                    >(
                        bookableWithoutDealerCode,
                        dealerCode,
                        OSB_API_PATH.OSB_CREATE_BOOKING,
                        args.callback
                    )
                    .then(response => {
                        try {
                            transformedResponse.value = transformServiceResponse(
                                response
                            );
                            resolve(transformedResponse);
                        } catch (err) {
                            transformedResponse.responseError.errorMessage =
                                'SERVICE_BOOKING_CLIENT_TRANSFORMATION_ERROR: ' +
                                (err as Error)?.message;
                            reject(transformedResponse.responseError);
                        }
                    })
                    .catch(_error => {
                        transformedResponse.responseError = transformErrorResponse(
                            _error
                        );
                        reject(transformedResponse.responseError);
                        console.error(
                            'Rejected the promise - ',
                            transformedResponse.responseError
                        );
                    });
            }
        );
    }
}
